import React from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CircleIcon from "@mui/icons-material/Circle";
import { green, orange } from "@mui/material/colors";

interface SensorStatusCardProps {
    sensorStatuses: string[];
}

const AllSensorStatusCard: React.FC<SensorStatusCardProps> = ({ sensorStatuses }) => {
    const offlineSensors = sensorStatuses.filter(status => status.toLowerCase() !== "online").length;
    const allOnline = offlineSensors === 0;

    return (
        <Card sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
            <MDBox display="flex" alignItems="center" gap={1}>
                <CircleIcon sx={{ color: allOnline ? green[500] : orange[500] }} />
                <MDTypography variant="h6" align="center">
                    {allOnline ? "All Online" : `${offlineSensors} Errors`}
                </MDTypography>
            </MDBox>
        </Card>
    );
};

export default AllSensorStatusCard;